import React from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

interface ChatInputAreaProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  disabled: boolean;
}

const ChatInputArea: React.FC<ChatInputAreaProps> = ({
  value,
  onChange,
  onKeyDown,
  onSend,
  disabled,
}) => (
  <InputContainer>
    <ChatInput
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder="Ask a question about your culture..."
      disabled={false}
    />
    <SendButton onClick={onSend} disabled={disabled} aria-label="Send message">
      <Icon name="send" />
    </SendButton>
  </InputContainer>
);

export default ChatInputArea;

const InputContainer = styled.div`
  display: flex;
  padding: 12px;
  border-top: 1px solid #e0e0e0;
  gap: 8px;
  align-items: center;
`;

const ChatInput = styled.textarea`
  flex: 1;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: Poppins, sans-serif;
  resize: none;
  max-height: 100px;
  min-height: 40px;
  &:focus {
    outline: none;
    border-color: #2d70e2;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const SendButton = styled.button`
  background-color: #2d70e2;
  border: none;
  border-radius: 14px;
  color: white;
  width: 48px;
  height: 48px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  > i,
  svg {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    width: 22px;
    height: 22px;
  }

  &:hover:not(:disabled) {
    background-color: #1a5bb8;
  }
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;
